<template>
  <FieldRowComponent
    :field
    :value="model"
    :rules
    :disabled
    :lockable
    v-slot="{ id, invalid, touch, disabled: inputDisabled }"
  >
    <NumberInput
      :id
      v-model="model"
      :invalid
      :disabled="inputDisabled"
      @blur="touch"
    />
  </FieldRowComponent>
</template>

<script setup lang="ts">
import type { ValidationRuleCollection } from "@vuelidate/core";
import type { RowFieldKey } from "./fieldKeys";
import FieldRowComponent from "./FieldRowComponent.vue";
import NumberInput from "./NumberInput.vue";

withDefaults(
  defineProps<{
    field: RowFieldKey;
    rules?: ValidationRuleCollection;
    disabled?: boolean;
    lockable?: boolean;
  }>(),
  {
    rules: () => ({}),
    disabled: false,
    lockable: false,
  }
);

const model = defineModel<number | null>({ default: null });
</script>
